module.exports = new __parcel__URL__("../iconoIFN.89400e25.svg").toString();